<template>
  <BasePaymentModal :name="name" @onProceed="emit('onProceed')">
    <template #title>
      {{ t('paymentErrorsModals.pay.title') }}
    </template>
    <template #description>
      {{ t('paymentErrorsModals.pay.description') }}
    </template>
    <template #buttonText>
      {{ t('paymentErrorsModals.retry') }}
    </template>
  </BasePaymentModal>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import BasePaymentModal from './BasePaymentModal.vue';

  defineProps<{ name: string }>();
  const emit = defineEmits<{ onProceed: [] }>();
  const { t } = useI18n();
</script>

<i18n src="../config/locales.json"></i18n>
